import React, { useState } from 'react';
import Footer from '../Footer/Footer';

export default function FrequentlyAskedQuestion() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const faqItems = [
    {
      question: "Right Creative agencies in the area?",
      answer: "While we would love to be able to give a definitive, fixed price for a website, it really depends on the specific needs for each individual business. If one business needs a website comprised of five pages, while another has a substantially larger site of over 100 pages - obviously those projects are going to command different price points."
    },
    {
      question: "Other top design agencies in the area?",
      answer: "This will vary depending on the type of project. For logo & branding projects, fees will be one-time costs. For website projects, we will typically charge a monthly fee, depending on the level of service you choose. To view a full list of our monthly packages, click here."
    },
    {
      question: "What separates us?",
      answer: "Logo projects typically cost between $3,000 - $5000. 'Why so much?' many people ask. To answer simply - because they require a lot of work. At least, to do them properly. And of all of the investments that you will make for your business, your logo & branding is one area where you don't want to skimp. In business, image is everything."
    },
    {
      question: "What separates Right Creative from other top design agencies in the area?",
      answer: "Experience, quality, and results. We have been designing websites professionally since the early days of the web. With over 20 years of experience, there are very few people in the world, let alone the area, that can top our years of experience."
    },
    {
      question: "What separates Right Creative from other top design agencies in the area?",
      answer: "Experience, quality, and results. We have been designing websites professionally since the early days of the web. With over 20 years of experience, there are very few people in the world, let alone the area, that can top our years of experience."
    },
    {
      question: "What separates Right Creative from other top design agencies in the area?",
      answer: "Experience, quality, and results. We have been designing websites professionally since the early days of the web. With over 20 years of experience, there are very few people in the world, let alone the area, that can top our years of experience."
    }
  ];

  return (
    <>
    <section className="faq-section" id="section3">
      <div className="faq-container">
        <div className="faq-text-wrapper">
          <div className="faq-text-container">
            <h1 className="section-title">Frequently Asked Questions</h1>
            <p className="section-description">
              "Features enable you to make the payment process hassle-free, with easy tracking, history, and invoices."
            </p>
          </div>
        </div>
        <div className="faq-card-container">
          <div className="accordion-container">
            <ul className="accordion-list">
              {faqItems.map((item, index) => (
                <li key={index} className={activeIndex === index ? 'active' : ''}>
                  <div
                    className="accordion-card"
                    onClick={() => toggleAccordion(index)}
                  >
                    <h3>{item.question}</h3>
                    <svg
                      className={`accordion-icon ${activeIndex === index ? 'rotate' : ''}`}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 50 50"
                    >
                      <g id="Layer_2" data-name="Layer 2">
                        <g id="Layer_1-2" data-name="Layer 1">
                          <path d="M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm0,47A22,22,0,1,1,47,25,22,22,0,0,1,25,47Z" />
                          <polygon
                            className={`icon-shape ${activeIndex === index ? 'cross' : ''}`}
                            points="26.5 12.5 23.5 12.5 23.5 23.5 12.5 23.5 12.5 26.5 23.5 26.5 23.5 37.5 26.5 37.5 26.5 26.5 37.5 26.5 37.5 23.5 26.5 23.5 26.5 12.5"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="answer">
                    <p>{item.answer}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
    <Footer/>
    </>
    
    
  );
}
